































































































import { Component, Vue, Watch } from "vue-property-decorator";
import LoginWidget from "@/components/LoginWidget.vue";
import ModalView from "@/components/design/ModalView.vue";
import { Account } from "@/types";
import { db, functions } from "@/firebase";

@Component({ components: { ModalView, LoginWidget } })
export default class MainView extends Vue {
  account: Account | null = null;

  roomName = "";

  inviteCode = "";
  redeemCodeError: string | null = null;

  showSubscribeModal = false;
  showSuccessModal = false;

  @Watch("user", { immediate: true })
  async onUserChange() {
    if (this.user) {
      const myUser = db.collection("users").doc(this.$store.state.user.data.uid);
      await this.$bind("account", myUser);
    }
  }

  async createRoom() {
    if (!this.user) {
      this.$router.push({ name: "Login", params: { nextUrl: this.$router.currentRoute.fullPath } });
      return;
    }

    if (!this.subscribed) {
      this.showSubscribeModal = true;
      return;
    }
    this.$store.commit("setLoading");
    const resp = await functions.httpsCallable("createRoom")();
    if (resp.data.success) {
      this.joinRoom(resp.data.id);
    } else {
      console.log(resp.data);
    }
    this.$store.commit("setNotLoading");
  }

  async practiceRoom() {
    if (!this.user) {
      this.$router.push({ name: "Login", params: { nextUrl: this.$router.currentRoute.fullPath } });
      return;
    }

    if (!this.subscribed) {
      this.showSubscribeModal = true;
      return;
    }
    this.$router.push({ name: "Practice" });
  }

  async joinRoom(roomId: string) {
    this.$router.push({ name: "Room", params: { id: roomId } });
    this.roomName = "";
  }

  get user() {
    return this.$store.state.user.loggedIn ? this.$store.state.user.data : null;
  }

  get subscribed() {
    const account = this.account;
    if (!(account && (account.subscription || account.betaActive))) {
      return false;
    } else {
      if (account.betaActive) {
        return true;
      }
      const subscription = account.subscription;
      return subscription.status == "trialing" || subscription.status == "active";
    }
  }

  async redeemCode() {
    this.$store.commit("setLoading");
    const confirmBetaCodeResult = await functions.httpsCallable("confirmBetaCode")(this.inviteCode);
    if (confirmBetaCodeResult.data.success) {
      this.showSubscribeModal = false;
      this.showSuccessModal = true;
      window.setTimeout(() => (this.showSuccessModal = false), 5000);
    } else {
      this.redeemCodeError = "You entered an invalid code. Are you sure you typed it correctly?";
    }
    this.$store.commit("setNotLoading");
  }
}
